import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("../spa/Login/Login"),
      meta: { noRequireAuth: true },
    },
    {
      path: "/logout",
      name: "Logout",
      component: () => import("../spa/Login/Logout"),
      meta: { noRequireAuth: true, isLogOut: true },
    },
    {
      path: "/good/:code",
      name: "GoodCode",
      component: () => import("../spa/Good/Index"),
      meta: { noRequireAuth: true },
    },
    {
      path: "/",
      component: () => import("../spa/Main/Index"),
      children: [
        { path: "", redirect: "schedule" },
        {
          path: "sale",
          component: () => import("../spa/Sale/Index"),
          children: [
            { path: "", redirect: "estimation" },
            {
              path: "estimation",
              name: "Estimation",
              component: () => import("../spa/Sale/Estimation"),
            },
            {
              path: "contract_reg",
              name: "ContractReg",
              component: () => import("../spa/Sale/ContractReg"),
            },
            {
              path: "contract",
              name: "Contract",
              component: () => import("../spa/Sale/Contract"),
            },
            {
              path: "contract_cancel",
              name: "ContractCancel",
              component: () => import("../spa/Sale/ContractCancel"),
            },
            {
              path: "production",
              name: "ProductionPlan",
              component: () => import("../spa/Sale/ProductionPlan"),
            },
            {
              path: "sale",
              name: "Sale",
              component: () => import("../spa/Sale/Sale"),
            },
            {
              path: "orders",
              name: "SaleOrders",
              component: () => import("../spa/Sale/SaleOrders"),
            },
            {
              path: "collect",
              name: "Collect",
              component: () => import("../spa/Sale/Collect"),
            },
            {
              path: "uncollected",
              name: "Uncollected",
              component: () => import("../spa/Sale/Uncollected"),
            },
            {
              path: "invoice",
              name: "SaleInvoice",
              component: () => import("../spa/Sale/Invoice"),
            },
            {
              path: "sale_stat",
              name: "SaleStat",
              component: () => import("../spa/Sale/SaleStat"),
            },
            {
              path: "note",
              name: "Note",
              component: () => import("../spa/Sale/Note"),
            },
            {
              path: "ledger",
              name: "SaleLedger",
              component: () => import("../spa/Sale/Ledger"),
            },
            {
              path: "collect_stat",
              name: "CollectStat",
              component: () => import("../spa/Sale/CollectStat"),
            },
          ],
        },
        {
          path: "production",
          component: () => import("../spa/Production/Index"),
          children: [
            { path: "", redirect: "plan" },
            {
              path: "plan",
              name: "Plan",
              component: () => import("../spa/Production/Plan"),
            },
            {
              path: "process",
              name: "ProductionProcess",
              component: () => import("../spa/Production/Process"),
            },
            {
              path: "pack",
              name: "Pack",
              component: () => import("../spa/Production/Pack"),
            },
            {
              path: "shipment",
              name: "Shipment",
              component: () => import("../spa/Production/Shipment"),
            },
          ],
        },
        {
          path: "stock",
          component: () => import("../spa/Stock"),
          children: [
            { path: "", redirect: "inbound" },
            {
              path: "stock",
              name: "Stock",
              component: () => import("../spa/Stock/Stock"),
            },
            {
              path: "stock_history",
              name: "StockHistory",
              component: () => import("../spa/Stock/StockHistory"),
            },
            {
              path: "inbound",
              name: "StockInbound",
              component: () => import("../spa/Stock/Inbound"),
            },
            {
              path: "serial",
              name: "Serial",
              component: () => import("../spa/Stock/Serial"),
            },
            {
              path: "good",
              name: "Good",
              component: () => import("../spa/Stock/Good"),
            },
          ],
        },
        {
          path: "service",
          component: () => import("../spa/Service"),
          children: [
            { path: "", redirect: "service_reg" },
            // { path: 'service_reg', name: 'ServiceReg', component: () => import('../spa/As/ServiceReg') },
            {
              path: "service",
              name: "Service",
              component: () => import("../spa/Service/Service"),
            },
            // { path: 'calendar', name: 'Calendar', component: () => import('../spa/AS/Calendar') },
            // { path: 'collection', name: 'Collection', component: () => import('../spa/AS/Collection') },
          ],
        },
        {
          path: "buy",
          component: () => import("../spa/Buy/Index"),
          children: [
            { path: "", redirect: "order_reg" },
            {
              path: "order_reg",
              name: "OrderReg",
              component: () => import("../spa/Buy/OrderReg"),
            },
            {
              path: "order",
              name: "Order",
              component: () => import("../spa/Buy/Order"),
            },
            {
              path: "inbound",
              name: "Inbound",
              component: () => import("../spa/Buy/Inbound"),
            },
            {
              path: "orders",
              name: "Orders",
              component: () => import("../spa/Buy/Orders"),
            },
            {
              path: "buy",
              name: "Buy",
              component: () => import("../spa/Buy/Buy"),
            },
            {
              path: "unpaid",
              name: "Unpaid",
              component: () => import("../spa/Buy/Unpaid"),
            },
            {
              path: "invoice",
              name: "BuyInvoice",
              component: () => import("../spa/Buy/Invoice"),
            },
            {
              path: "pay",
              name: "Pay",
              component: () => import("../spa/Buy/Pay"),
            },
            {
              path: "ledger",
              name: "BuyLedger",
              component: () => import("../spa/Buy/Ledger"),
            },
            {
              path: "buy_stat",
              name: "BuyStat",
              component: () => import("../spa/Buy/BuyStat"),
            },
            {
              path: "pay_stat",
              name: "PayStat",
              component: () => import("../spa/Buy/PayStat"),
            },
          ],
        },
        {
          path: "base",
          component: () => import("../spa/Base/Index"),
          children: [
            { path: "", redirect: "code" },
            {
              path: "code",
              name: "Code",
              component: () => import("../spa/Base/Code"),
            },
            {
              path: "customer",
              name: "Customer",
              component: () => import("../spa/Base/Customer"),
            },
            {
              path: "customer_level",
              name: "CustomerLevel",
              component: () => import("../spa/Base/CustomerLevel"),
            },
            {
              path: "client_level",
              name: "ClientLevel",
              component: () => import("../spa/Base/ClientLevel"),
            },
            {
              path: "product",
              name: "Product",
              component: () => import("../spa/Base/Product"),
            },
            {
              path: "history",
              name: "History",
              component: () => import("../spa/Base/History"),
            },
            {
              path: "cost",
              name: "Cost",
              component: () => import("../spa/Base/Cost"),
            },
            {
              path: "glass_cost",
              name: "GlassCost",
              component: () => import("../spa/Base/GlassCost"),
            },
            {
              path: "bom",
              name: "Bom",
              component: () => import("../spa/Base/Bom"),
            },
            {
              path: "product_type",
              name: "ProductType",
              component: () => import("../spa/Base/ProductType"),
            },
            {
              path: "product_category",
              name: "ProductCategory",
              component: () => import("../spa/Base/ProductCategory"),
            },
            {
              path: "area",
              name: "Area",
              component: () => import("../spa/Base/Area"),
            },
            {
              path: "glass",
              name: "Glass",
              component: () => import("../spa/Base/Glass"),
            },
            {
              path: "option",
              name: "Option",
              component: () => import("../spa/Base/Option"),
            },
            {
              path: "company",
              name: "Company",
              component: () => import("../spa/Base/Company"),
            },
            {
              path: "door",
              name: "Door",
              component: () => import("../spa/Base/Door"),
            },
          ],
        },
        {
          path: "management",
          component: () => import("../spa/Management/Index"),
          children: [
            { path: "", redirect: "r_note" },
            {
              path: "r_note",
              name: "ReceiveNote",
              component: () => import("../spa/Management/ReceiveNote"),
            },
            {
              path: "p_note",
              name: "PurchaseNote",
              component: () => import("../spa/Management/PurchaseNote"),
            },
          ],
        },
        {
          path: "schedule",
          component: () => import("../spa/Schedule/Index"),
          children: [
            { path: "", redirect: "dashboard" },
            {
              path: "dashboard",
              name: "Dashboard",
              component: () => import("../spa/Schedule/Dashboard"),
            },
            {
              path: "schedule",
              name: "Schedule",
              component: () => import("../spa/Schedule/Schedule"),
            },
          ],
        },
        {
          path: "asset",
          component: () => import("../spa/Asset/Index"),
          children: [
            { path: "", redirect: "account" },
            {
              path: "account",
              name: "Account",
              component: () => import("../spa/Asset/Account"),
            },
            {
              path: "asset_category",
              name: "AssetCategory",
              component: () => import("../spa/Asset/AssetCategory"),
            },
            {
              path: "asset_reg",
              name: "AssetReg",
              component: () => import("../spa/Asset/AssetReg"),
            },
            {
              path: "asset_status",
              name: "AssetStatus",
              component: () => import("../spa/Asset/AssetStatus"),
            },
            {
              path: "settlement",
              name: "Settlement",
              component: () => import("../spa/Asset/Settlement"),
            },
          ],
        },
        {
          path: "/system",
          component: () => import("../spa/System"),
          children: [
            {
              path: "user",
              name: "User",
              component: () => import("../spa/System/User"),
            },
            {
              path: "group",
              name: "Group",
              component: () => import("../spa/System/Group"),
            },
            {
              path: "branch",
              name: "Branch",
              component: () => import("../spa/System/Branch"),
            },
            {
              path: "notice",
              name: "Notice",
              component: () => import("../spa/System/Notice"),
            },
          ],
        },
      ],
    },
    {
      path: "/sample",
      component: () => import("../sample/Index"),
      children: [
        {
          path: "dialog",
          name: "SampleDialog",
          component: () => import("../sample/SampleDialog"),
        },
        {
          path: "date",
          name: "SampleDatePicker",
          component: () => import("../sample/SampleDatePicker"),
        },
        {
          path: "autocomplete",
          name: "SampleSelectControl",
          component: () => import("../sample/SampleSelectControl"),
        },
        {
          path: "comma",
          name: "SampleFilterComma",
          component: () => import("../sample/SampleFilterComma"),
        },
        {
          path: "korean",
          name: "SampleNumberToKorean",
          component: () => import("../sample/SampleNumberToKorean"),
        },
        {
          path: "calculation",
          name: "SampleCalculation",
          component: () => import("../sample/SampleCalculation"),
        },
        {
          path: "form",
          name: "SampleForm",
          component: () => import("../sample/SampleForm"),
        },
        {
          path: "list",
          name: "SampleList",
          component: () => import("../sample/SampleList"),
        },
        {
          path: "table",
          name: "SampleTable",
          component: () => import("../sample/SampleTable"),
        },
        {
          path: "websocket",
          name: "SampleWebsocket",
          component: () => import("../sample/SampleWebsocket"),
        },
        {
          path: "periodSelector",
          name: "SamplePeriodSelector",
          component: () => import("../sample/SamplePeriodSelector"),
        },
        {
          path: "tradeTable",
          name: "SampleTradeTable",
          component: () => import("../sample/SampleTradeTable"),
        },
        {
          path: "numberKey",
          name: "SampleNumberKey",
          component: () => import("../sample/SampleNumberKey"),
        },
        {
          path: "cors",
          name: "SampleCors",
          component: () => import("../sample/SampleCors"),
        },
      ],
    },
  ],
});
